import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b" style={{
    borderColor: 'var(--color-border)'
  }} data-id="element-30">
      <button onClick={onToggle} className="w-full py-6 flex items-center justify-between text-left" aria-expanded={isOpen} data-id="element-31">
        <span className="text-lg font-semibold pr-4" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-32">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} style={{
        color: 'var(--color-accent)'
      }} data-id="element-33" />
      </button>
      <AnimatePresence data-id="element-34">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="overflow-hidden" data-id="element-35">
            <p className="pb-6" style={{
          color: 'var(--color-text)',
          opacity: 0.8
        }} data-id="element-36">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Will they hate me during the detox?',
    answer: 'They might be angry for the first 12 hours. This guide shows you how to be their "calm anchor" so they feel safe, even while they are frustrated.'
  }, {
    question: 'Does this work for ADHD kids?',
    answer: 'High-stimulus screens are often hardest on neurodivergent brains; this reset is specifically designed to help calm those overstimulated circuits.'
  }, {
    question: 'Do I have to stay home all weekend?',
    answer: 'It is recommended to stay close to the "Activity Menu" for the first 24 hours to ensure the reset sticks.'
  }, {
    question: "What if my partner isn't on board?",
    answer: 'The guide includes a section on getting buy-in from reluctant partners, with talking points and shared goals that help align your approach.'
  }];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-12 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-39">
          Frequently Asked Questions
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} data-id="element-40">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-41" />)}
        </motion.div>
      </div>
    </section>;
}